import About from './views/About';
import Header from './views/Header';
import Info from './views/Info';
import Services from './views/Services';
import Contact from './views/Contact.jsx';
import Instructions from './views/Instructions.jsx';
import Footer from './views/Footer';
import FileUpload from './views/FileUpload';
import FileDownload from './views/FileDownload';
import EspaceClient from './views/EspaceClient.jsx';
import HeaderClient from './views/HeaderClient.jsx';
import AboutClient from './views/AboutClient.jsx';
import InfoClient from './views/InfoClient.jsx';
import ServicesClient from './views/ServicesClient.jsx';
import ContactClient from './views/LegacyViews/ContactClient.jsx';
import ModifiedInfo from './views/ModifiedInfo.jsx';
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useState, useEffect } from 'react'
import { Toaster } from "react-hot-toast";

function App() {
  const [currentView, setCurrentView] = useState("home"); // "home", "client" or "instruction"
  const [currentClientView, setCurrentClientView] = useState("client"); // "home", "client" or "instruction"
  const [user, setUser] = useState(null);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  if (user) {
    return (
      <>
        <Toaster position="top-right" />
        <HeaderClient setCurrentClientView={setCurrentClientView} />
        <AboutClient />
        <InfoClient />
        <ServicesClient />
        <Contact />
        <Footer />
      </>
    )
  } else {
    return (

      <>
        <Toaster position="top-right" />
        <Header setCurrentView={setCurrentView} />


        {currentView === "instruction" && (
          <div id="instructions-content">
            <Instructions />
          </div>
        )}
        {currentView === "home" && (
          <div id="main-content">
            <About />
            <Info />
            <Services />
            <Contact />
          </div>
        )}
        {currentView === "client" && (
          <div id="espace-client">
            <About />
            <ModifiedInfo />
          </div>
        )}

        <Footer />

        <a href="#" className="scroll-top btn-hover">
          <i className="lni lni-chevron-up"></i>
        </a>
      </>
    );
  }
}

export default App;
